module.exports = __webpack_public_path__ + "static/media/woman.ac3166ba.jpg";